$(function () {
	if ($('.catalog').length) {
		$('.js-tab-item').click(function () {
			if ($(this).hasClass('tab__item_map')) {
				$('.catalog .tab-content').parent().addClass('container_wide');
			} else {
				$('.catalog .tab-content').parent().removeClass('container_wide');
			}
		});
	}
})